import React from "react";
import Skeleton from "react-loading-skeleton";
import { ReactComponent as Chevron } from "../../assets/chevron.svg";
import { RollingCoinsType } from "../../compilers/RollingCoins";
import "../../stylesheet/components/rollingcoins/RollingCoins.scss";

type RollingCoinProps = {
  coins: RollingCoinsType[];
  currency: string;
  icon: string;
};

const numberOfCoins = 12;

const RollingCoins: React.FC<RollingCoinProps> = ({
  coins,
  currency,
  icon,
}) => {
  const coin = () => {
    if (coins.length > 1) {
      return coins.slice(0, 12).map((coin, i: number) => {
        if (coin) {
          return (
            <div key={i} className="individual-coin flex">
              <p className="p2 individual-coin__symbol">{coin.symbol}</p>
              <p className="p2 individual-coin__price">
                {icon}
                {coin.current_price.toFixed(2)}
              </p>
              <p className="p2 individual-coin__change-percentage">
                {String(coin.price_change_percentage_24h).includes("-") ? (
                  <span className="down">
                    {String(coin.price_change_percentage_24h.toFixed(2))}%
                  </span>
                ) : (
                  <span className="up">
                    {String(coin.price_change_percentage_24h.toFixed(2))}%
                  </span>
                )}
              </p>
            </div>
          );
        }
      });
    }

    return [...Array(numberOfCoins)].map((skeleton, i: number) => {
      return (
        <div key={i} className="individual-coin flex">
          <Skeleton width={40} />
          <Skeleton width={100} />
          <Skeleton width={60} />
        </div>
      );
    });
  };

  return (
    <>
      <div className="rolling-coin-wrapper">{coin()}</div>
      <div
        data-bs-toggle="modal"
        data-bs-target="#coinOverlay"
        className="flex-r flex-end coins-dropdown"
      >
        <p className="p2">{currency} </p>
        <Chevron className="icon" />
      </div>
    </>
  );
};

export default RollingCoins;
